import React from 'react';
import { AlertCircle } from 'lucide-react';
import { RobbieMark } from '../ui';
import { NotificationItem } from '../../client/notificationsClient';

/**
 * Body of a research notification in the bell: Robbie's mark when supplier
 * research is ready, an amber alert when it came back with nothing. Wording
 * matches the research email so the two never disagree.
 */
export interface ResearchNotificationTextProps {
  notification: NotificationItem;
  unread: boolean;
  when?: string;
}

export const ResearchNotificationText: React.FC<ResearchNotificationTextProps> = ({ notification, unread, when }) => {
  const ready = notification.type === 'RESEARCH_READY';
  const name = notification.rfqName || notification.rfqId;
  const meta = [notification.body, when].filter(Boolean).join(' · ');
  return (
    <span className="flex min-w-0 flex-1 items-start gap-s3">
      {ready ? (
        <RobbieMark size="xs" aria-label="Robbie" className="shrink-0" />
      ) : (
        <AlertCircle aria-hidden="true" className="mt-[1px] h-4 w-4 shrink-0 text-warn-ink" />
      )}
      <span className="min-w-0 flex-1">
        <span className="block text-body-sm text-ink-body">
          Supplier research for{' '}
          <span className={`text-ink ${unread ? 'font-semibold' : 'font-medium'}`}>{name}</span>{' '}
          {ready ? 'is ready' : 'needs a look'}
        </span>
        {meta && <span className="mt-s1 line-clamp-2 block text-meta text-ink-muted">{meta}</span>}
      </span>
    </span>
  );
};

export default ResearchNotificationText;
